import { FC } from "react";
import BiensOffMarketHoverPopup from './BiensOffMarketHoverPopup';
import DefaultHoverPopup from './DefaultHoverPopup';

interface HoverPopupContentProps {
  hoveredData: string;
}

const HoverPopupContent: FC<HoverPopupContentProps> = ({ hoveredData }) => {
  // Try to parse as JSON for enhanced biens_off_market data
  let parsedData = null;
  try {
    parsedData = JSON.parse(hoveredData);
  } catch {
    // Not JSON, treat as simple address string
  }

  if (parsedData?.isOffMarket) {
    // Enhanced display for biens_off_market using dedicated component
    return <BiensOffMarketHoverPopup data={parsedData} />;
  }

  // Default display for regular transactions
  return <DefaultHoverPopup address={hoveredData} />;
};

export default HoverPopupContent;
